module.exports = __webpack_public_path__ + "img/mms.11935032.png";